import { render, staticRenderFns } from "./Msu.vue?vue&type=template&id=c2afcf9a&scoped=true"
import script from "./Msu.vue?vue&type=script&lang=js"
export * from "./Msu.vue?vue&type=script&lang=js"
import style0 from "./Msu.vue?vue&type=style&index=0&id=c2afcf9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2afcf9a",
  null
  
)

export default component.exports